import React, { CSSProperties } from 'react';
import { Grid, Label, Segment, Table } from 'semantic-ui-react';

import { NombrePersonal } from 'src/componentes';
import { AlumnoConAsistencia } from './tipos';

type Props = Readonly<{
    asistencias: readonly AlumnoConAsistencia[];
    borde?: 'verde' | 'rojo';
    alPresionarFilaAlumno: (indice: number) => void;
}>;

const bordeVerde: CSSProperties = {
    boxShadow: '0 0 8px #5ada5a',
};

const bordeRojo: CSSProperties = {
    boxShadow: '0 0 8px #da7a54',
};

export const ListaDeAlumnos = (props: Props) => {
    const { asistencias, alPresionarFilaAlumno, borde } = props;

    const presentes = asistencias.filter(a => a.presente).length;
    const ausentes = asistencias.length - presentes;

    const estiloBorde = !borde ? undefined : borde === 'verde' ? bordeVerde : bordeRojo;

    return (
        <div style={estiloBorde}>
            <Table striped selectable unstackable attached='top'>
                <Table.Body>
                    {asistencias.map((asistencia, indice) => (
                        <Fila
                            key={indice}
                            alumno={asistencia}
                            indice={indice}
                            numero={indice + 1}
                            alPresionarFila={alPresionarFilaAlumno}
                        />
                    ))}
                </Table.Body>
            </Table>

            <Segment attached='bottom'>
                <Grid columns={2} textAlign='center'>
                    <Grid.Column>
                        <span style={{ fontWeight: 'bold', color: 'green' }}>
                            Presentes: {presentes}
                        </span>
                    </Grid.Column>

                    <Grid.Column>
                        <span style={{ fontWeight: 'bold', color: 'red' }}>
                            Ausentes: {ausentes}
                        </span>
                    </Grid.Column>
                </Grid>
            </Segment>
        </div>
    );
};

const Fila = (props: {
    alumno: AlumnoConAsistencia;
    indice: number;
    numero: number;
    alPresionarFila: (indice: number) => void;
}) => {
    const { alumno, numero, indice, alPresionarFila } = props;

    return (
        <Table.Row
            key={alumno.idAlumno}
            style={{ cursor: 'pointer' }}
            onClick={() => alPresionarFila(indice)}
        >
            <Table.Cell width='2'>{numero}</Table.Cell>

            <Table.Cell width='12'>
                <NombrePersonal nombre={alumno.nombre} patron='%P %M %N %S' />
            </Table.Cell>

            <Table.Cell width='2'>
                <Label
                    content={alumno.presente ? 'P' : 'A'}
                    color={alumno.presente ? 'green' : 'red'}
                    circular
                />
            </Table.Cell>
        </Table.Row>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Asistencia/paginas/AsistenciaDelCurso/ListaDeAlumnos.tsx